import {NavLink, useParams} from 'react-router-dom';

import {
    Box,
    Breadcrumbs,
} from '@mantine/core';
import {Subscription} from '../types';

export const EditPageNavigation = ({component}: { component: Subscription }) => {
    const { id: customerId } = useParams();

    const breadcrumbs = [{
        title: 'Home',
        href: '/dashboard',
    },
        {
            title: 'Customers',
            href: '/customers',
        },
        {
            title: customerId?.substring(0, 8) + '...',
            href: `/customers/${customerId}`,
        },
        {
            title: 'Subscriptions',
            href: `/customers/${customerId}?tab=subscriptions`,
        },
        {title: component.id.substring(0, 8) + '...'}].map((item, index) => (
        <Box key={index}> {
            item
                .href ?
                <NavLink to={item.href}>{item.title}</NavLink> : item.title
        }
        </Box>
    ));

    return (
        <Box p={'xs'}><Breadcrumbs separator='→' mt='xs'>{breadcrumbs}</Breadcrumbs></Box>
    );
};
